


export async function redirectOnHomePage(){
    window.setTimeout(() => location.assign('/'), 5 * 1000); //
}